/**
 * @generated SignedSource<<a3cc1b4b9fcab622dd86bbc5e000c7db>>
 * @relayHash 694e5076d8b794c7fd127d30ba8e0bfd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1f087b092d04fae3500eb388cb13b128433088d13aee1dd5bda1fd57d932b1ba

import type { ConcreteRequest, Query } from 'relay-runtime';
export type mainGoalsPopupContentQuery$variables = {
  cloudId: string;
};
export type mainGoalsPopupContentQuery$data = {
  readonly townsquare: {
    readonly allWorkspacesForOrg: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly cloudId: string;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type mainGoalsPopupContentQuery = {
  response: mainGoalsPopupContentQuery$data;
  variables: mainGoalsPopupContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "cloudId"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "mainGoalsPopupContentQuery",
    "selections": [
      {
        "concreteType": "TownsquareQueryApi",
        "kind": "LinkedField",
        "name": "townsquare",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "TownsquareWorkspaceConnection",
            "kind": "LinkedField",
            "name": "allWorkspacesForOrg",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareWorkspaceEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareWorkspace",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "mainGoalsPopupContentQuery",
    "selections": [
      {
        "concreteType": "TownsquareQueryApi",
        "kind": "LinkedField",
        "name": "townsquare",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "TownsquareWorkspaceConnection",
            "kind": "LinkedField",
            "name": "allWorkspacesForOrg",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareWorkspaceEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareWorkspace",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "1f087b092d04fae3500eb388cb13b128433088d13aee1dd5bda1fd57d932b1ba",
    "metadata": {},
    "name": "mainGoalsPopupContentQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d50a544b76c5c81094a02351bd1dd9ff";

export default node;
